import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EntitlementService {
  entitlements: any[];
  constructor() {}

  setEntitlements(userEntitlements: any[]) {
    this.entitlements = userEntitlements;
  }

  hasEntitlement(entitlement: string): boolean {
    return this.entitlements && this.entitlements.indexOf(entitlement) > -1;
  }

  getEntitlements() {
    return this.entitlements;
  }
}
